import { SyncOutlined } from '@ant-design/icons';
import { Alert, Progress } from 'antd';
import React, { FC } from 'react';

interface SyncProgressBannerProps {
  processed: number;
  total: number;
}

export const SyncProgressBanner: FC<SyncProgressBannerProps> = ({ processed, total }) => {
  const percent = total > 0 ? Math.round((processed / total) * 100) : 0;

  return (
    <Alert
      type="info"
      icon={<SyncOutlined spin />}
      showIcon
      banner
      message={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span>
            Syncing catalog items... {processed.toLocaleString()}/{total.toLocaleString()}
          </span>
          <Progress percent={percent} size="small" style={{ flex: 1, marginBottom: 0 }} />
        </div>
      }
      style={{ marginBottom: 8 }}
    />
  );
};
